export const deleteAccount = (data) => ({
    url: `/admin/delete-account`,
    method: "POST",
    body: { ...data }
})